import { store, getContext, getElement, getConfig } from '@wordpress/interactivity';

(function($){

    // Toggle agenda mobile

    $(document).on('click','.cnm-agenda-toggle-mobile', function(e){
        $('.cnm-agenda-main-toggle').first().click();
    });

    // Toggle

    $(document).on('click','.cnm-menu__toggle-list', function(e){
        $('.cnm-menu__list').toggleClass('toggled');
        $('i', this).toggleClass('cnm-icon-BurgerMenu');
        $('i', this).toggleClass('cnm-icon-Close');
        let ariaexpanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', ariaexpanded == "true" ? "false" : "true");
        focusTrap($('#cnm-main-menu'));
        $('.cnm-menu__list__item').first().find('a').focus();
        e.preventDefault();
    });

    $(document).on('click','.cnm-menu__list__item a', function(){

        // $(this).focus();

        focusTrap($('nav#cnm-main-menu'));

        // if (!window.matchMedia("screen and (max-width: 768px)")){               

            $("html, body").animate({ scrollTop: 0 }, 300);

        // }

        $('.cnm-menu__list__item a').not($(this)).removeClass('active');
        
        $(this).toggleClass('active');

        if (window.matchMedia("screen and (max-width: 768px)").matches){    
            if(subMenuId != undefined) toggleTab(subMenuId);           
            $('.cnm-menu__submenus').insertAfter($(this));
        }

        var subMenuId = $(this).data('id');

        if($(this).hasClass('active')){

            // Get sub-menu in ajax if not loaded
            if($('.cnm-menu__submenu[data-id="'+subMenuId+'"]').length == 0){
                
                $.ajax({
                    url: adminvars.ajaxurl, 
                    type: "POST",
                    data: {
                        'action':'cnm_display_menu_content',
                        'subMenuId':subMenuId 
                    }
                }).done(function(datas){
                    $('.cnm-menu__submenus').append("<div class='cnm-menu__submenu' data-id='"+subMenuId+"'>" + datas + "</div>");
                    toggleTab(subMenuId);
                });

            }
            else{
                toggleTab(subMenuId);
            }


        }
        else{
            closeMenu();
        }

    });

    $(window).on('click', function (e) {
        if($("#cnm-main-menu").find(e.target).length == 0 && $('.cnm-menu-toggled').length > 0){
            closeMenu();
        }
    });

    $(document).on('click', "#cnm-menu-close", function(){
        closeMenu();
    });

    $(document).on('keyup', function(event) { 
        if (event.key == "Escape") { 
            closeMenu();
        } 
    }); 

    
    // Aria hidden on menu

    $(window).on('load resize', function(){
        if (window.matchMedia("(min-width: 993px)").matches) {
            $('.cnm-menu__list').attr('aria-hidden',"false");
        }
        else{
            $('.cnm-menu__list').attr('aria-hidden', "true");
        }
    });

    function toggleTab(subMenuId){
        openMenu();
        $('.cnm-menu__submenu').hide();
        $('.cnm-menu__submenu[data-id="'+subMenuId+'"]').show();
        $('.cnm-menu__submenu[data-id="'+subMenuId+'"] a').first().focus();
    }

    function openMenu(){
        
        if($('.cnm-search-form__form').is('visible')) $('.cnm-search-form__close').click();
        
        $('body').addClass('cnm-popup-toggled');
        $('body').addClass('cnm-menu-toggled');

        if($('#cnm-menu-close').length == 0){
            $('#cnm-menu-close-wrap').prepend('<a href="#" id="cnm-menu-close"><i class="cnm-icon-Close"></i> Fermer</a>');
        }
    }

    function closeMenu(){

        if(!$('body').hasClass('cnm-menu-toggled')) return;

        $('.cnm-menu__list').removeClass('toggled');
        $('i', '.cnm-menu__toggle-list').addClass('cnm-icon-BurgerMenu');
        $('i', '.cnm-menu__toggle-list').removeClass('cnm-icon-Close');
        let ariaexpanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', ariaexpanded == "true" ? "false" : "true");
        $('button.cnm-menu__header-mobile__group__button.cnm-menu__toggle-list').focus();


        if(!$('body').hasClass('cnm-agenda-toggled')){
            $('body').removeClass('cnm-popup-toggled');
        }

        $('body').removeClass('cnm-menu-toggled');
        $('.cnm-menu__submenu').hide();
        $('#cnm-menu-close').remove();
        $('.cnm-menu__list__item a').removeClass('active');
    }

    var focusTrap = function(elem) {
    
        var tabbable = elem.find('select, input, textarea, button, a').filter(':visible');
        
        var firstTabbable = tabbable.first();
        var lastTabbable = tabbable.last();
        /*set focus on first input*/
        firstTabbable.focus();
    
        /*redirect last tab to first input*/
        lastTabbable.on('keydown', function (e) {
           if ((e.which === 9 && !e.shiftKey)) {
               e.preventDefault();
               firstTabbable.focus();
           }
        });
    
        /*redirect first shift+tab to last input*/
        firstTabbable.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastTabbable.focus();
            }
        });
        
        /* allow escape key to close insiders div */
        elem.on('keyup', function(e){
          if (e.keyCode === 27 || e.key == "Escape") {
            closeMenu();
          };
        });
    };

})(jQuery);